import { WebSocketConnection } from "@rosette/ts/src/business/game/server/WebSocketConnection.js";
import { useOptionalRune } from "@rosette/react_utils/src/useRune.js";
import { useEffect, useMemo } from "react";
import { browserStorageAdapter } from "./storage/browserStorage.js";


export function useWebSocketConnection(
    url: string | null,
): {
    connected: boolean;
    connection: WebSocketConnection | null;
} {

    const connection = useMemo(() => {
        if (url === null)
            return null;

        return new WebSocketConnection(url, browserStorageAdapter);
    }, [url]);

    // Connect.
    useEffect(() => connection?.setup(), [connection]);

    // Read connection status.
    const connected = useOptionalRune(connection?.getConnected()) ?? false;

    return { connected, connection };
}
